import React from 'react';
export function Guarantee() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 relative" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(248,251,255) 0%, rgb(248,251,255) 85%, rgb(224,242,254) 100%)'
  }} data-id="element-208">
      <div className="mx-auto max-w-2xl" data-id="element-209">
        <div className="rounded-2xl overflow-hidden shadow-sm text-center" style={{
        border: '1px solid rgba(14,165,233,0.3)'
      }} data-id="element-210">
          {/* Header */}
          <div className="px-6 py-5" style={{
          background: 'linear-gradient(135deg, #0369a1 0%, #0284c7 100%)'
        }} data-id="element-211">
            <div className="text-4xl mb-2" data-id="element-212">🛡️</div>
            <h2 className="text-lg font-black text-white m-0" data-id="element-213">
              Garantía de 7 días — Sin preguntas
            </h2>
          </div>

          {/* Body */}
          <div className="px-6 py-6" style={{
          backgroundColor: 'rgb(240,249,255)'
        }} data-id="element-214">
            <p className="text-2xl font-black m-0 mb-2" style={{
            color: '#0284c7'
          }} data-id="element-215">
              Te devolvemos el 100%.
            </p>
            <p className="text-sm text-gray-600 m-0" data-id="element-216">
              Si en 7 días no es lo que esperabas, escribinos y listo.
              <br data-id="element-217" />
              Sin formularios. Sin drama.
            </p>
          </div>
        </div>
      </div>

      {/* Degradé de integración con Testimonials */}
      <div className="absolute bottom-0 left-0 right-0 h-16 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent 0%, rgb(224,242,254) 100%)'
    }} data-id="element-218" />
    </section>;
}